/**
 * Mapping of category names to URL-friendly slugs
 */
const CATEGORY_SLUG_MAP: Record<string, string> = {
  'Phone cases': 'phone-cases',
  Keychains: 'keychains',
  Pets: 'pets',
  Paintings: 'paintings',
  Fidgets: 'fidgets',
  Cups: 'cups',
  All: 'all',
  'New arrivals': 'new arrivals',
  'About Us': 'about-us',
  Contacts: 'contacts',
  'Legal Policies': 'legal-policies',
  'Privacy Policy': 'privacy-policy',
  'Terms of Service': 'terms-of-service',
  'Refund & Return Policy': 'refund-return-policy',
  'Complaints & Warranty Policy': 'complaints-warranty-policy',
  'Shipping Policy': 'shipping-policy',
};

const CATEGORY_SLUG_LOCALIZATION_MAP: Record<string, string> = {
  'phone-cases': 'general.breadcrumbs.category.phonecases',
  keychains: 'general.breadcrumbs.category.keychains',
  pets: 'general.breadcrumbs.category.pets',
  paintings: 'general.breadcrumbs.category.paintings',
  fidgets: 'general.breadcrumbs.category.fidgets',
  cups: 'general.breadcrumbs.category.cups',
  all: 'general.breadcrumbs.category.all',
  'new arrivals': 'general.breadcrumbs.category.new',
  'about-us': 'about.us.page.title',
  contacts: 'contacts.page.title',
  'legal-policies': 'legal.policies.page.title',
  'privacy-policy': 'privacy.policy.page.title',
  'terms-of-service': 'terms.of.service.page.title',
  'refund-return-policy': 'refund.return.policy.page.title',
  'complaints-warranty-policy': 'complaints.warranty.policy.page.title',
  'shipping-policy': 'shipping.policy.page.title',
};

/**
 * Converts a category name to a URL-friendly slug
 * Example: "Чохли на телефон" -> "chokhly-na-telefon"
 */
export const categoryNameToSlug = (categoryName: string): string => {
  // First try to find in mapping
  if (CATEGORY_SLUG_MAP[categoryName]) {
    return CATEGORY_SLUG_MAP[categoryName];
  }

  // Fallback to automatic conversion
  return categoryName
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Remove diacritics
    .replace(/[^a-z0-9\s-]/g, '') // Remove special characters
    .trim()
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/-+/g, '-'); // Replace multiple hyphens with single hyphen
};

/**
 * Converts a slug back to a category name
 */
export const slugToCategoryName = (slug: string): string | null => {
  // First try to find in mapping

  if (CATEGORY_SLUG_LOCALIZATION_MAP[slug]) {
    return CATEGORY_SLUG_LOCALIZATION_MAP[slug];
  }

  return null;
};
